import type { RouteRecordRaw } from 'vue-router';

export const auditLogsRoutes: RouteRecordRaw[] = [
  {
    path: '/audit-logs',
    name: 'audit-logs',
    component: () => import('./views/AuditLogsView.vue'),
    meta: {
      title: 'Audit Logs',
      breadcrumbs: [{ label: 'Audit Logs' }],
      modulePermission: 'auditLogs',
    },
  },
];
